export enum Keyboard {
    Escape = 'Escape',
}
